


async function clientesPDF(clientes){
    const pdfMake = (await import( 'pdfmake/build/pdfmake.min')).default;
    const pdfFonts = (await import('pdfmake/build/vfs_fonts')).default;
    
    pdfMake.vfs = pdfFonts.vfs;

    const reporTitle = [{
        text: 'SINTUFF - Ação PSS',
        fontSize: 15,
        bold: true,
        margin: [15, 20, 0, 45]
    }];

    const dados = clientes.map((cliente) => {
        return [
            {text: cliente.nome, fontSize: 9, margin: [0, 2, 0, 2]},
            {text: cliente.cpf, fontSize: 9, margin: [0, 2, 0, 2]},
            {text: cliente.processo, fontSize: 9, margin: [0, 2, 0, 2]},
            {text: cliente.valor, fontSize: 9, margin: [0, 2, 0, 2]}
        ]
    })
     
    const details = [
        {
            table:{
                headerRows: 1,
                widths: [200, 120, 120, 80],
                body: [
                    [
                        {text: 'Nome', style: 'tableHeader', fontSize: 10},
                        {text: 'CPF', style: 'tableHeader', fontSize: 10},
                        {text: 'Processo', style: 'tableHeader', fontSize: 10},
                        {text: 'Valor', style: 'tableHeader', fontSize: 10}
                    ],
                    ...dados

                ]
            },
            layout: 'lightHorizontalLines'  //'headerLineOnly' 
        }
    ];

    function Rodape(currentPage, pageCount){
        return [
        {
          text: currentPage + ' / ' + pageCount,
          fontSize: 9,
          alignment: 'right',
          margin: [0, 10, 20, 0]
        }
        ]
    }

    const docDefinitions = {
        pageSize: 'A4',
        pageMargins: [15,50,15,40],
        header: [reporTitle],
        content: [details],
        footer: [Rodape]
    }

    pdfMake.createPdf(docDefinitions).download();

}
export default clientesPDF;